import React, { useState, useEffect } from 'react';
import './PhotosTab.scss';

const PhotosTab = ({ matchPhotos }) => {
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);
  const [showGallery, setShowGallery] = useState(false);

  const getPhotoUrl = (index) => {
    if (!matchPhotos || matchPhotos.length === 0) return '';
    const normalizedIndex = (index + matchPhotos.length) % matchPhotos.length;
    return matchPhotos[normalizedIndex].url;
  };

  const goToPhoto = (index) => {
    if (!matchPhotos || matchPhotos.length === 0) return;
    const normalizedIndex = (index + matchPhotos.length) % matchPhotos.length;
    setCurrentPhotoIndex(normalizedIndex);
  };

  const toggleGallery = () => {
    setShowGallery(!showGallery);
  };

  // Function to handle key press
  const handleKeyPress = (event) => {
    if (event.key === 'Escape') {
      setShowGallery(false);
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  if (!matchPhotos || matchPhotos.length === 0) {
    return (
      <div className='photos-tab'>
        <div className='photos-header'>
          <h3>Match Photos</h3>
          <p>Photos from the match will appear here</p>
        </div>
        <div className='no-photos'>
          <div className='no-photos-content'>
            <div className='no-photos-icon'>📸</div>
            <p>No photos available for this match</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='photos-tab'>
      <div className='photos-header'>
        <h3>Match Photos</h3>
        <p>
          {matchPhotos.length} photo{matchPhotos.length !== 1 ? 's' : ''} available
        </p>
      </div>

      {showGallery && (
        <div className='photo-gallery-modal'>
          <button className='close-gallery' onClick={toggleGallery}>
            ✕
          </button>
          <div className='gallery-grid'>
            {matchPhotos.map((photo, index) => (
              <div
                key={index}
                className={`gallery-item ${index === currentPhotoIndex ? 'active' : ''}`}
                onClick={() => {
                  setCurrentPhotoIndex(index);
                  setShowGallery(false);
                }}
              >
                <img src={photo.url} alt={`Photo ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
      )}

      <div className='photo-viewer'>
        <div className='preview-photo prev-photo' onClick={() => goToPhoto(currentPhotoIndex - 1)}>
          <img src={getPhotoUrl(currentPhotoIndex - 1)} alt='Previous' />
          <div className='photo-nav-hint'>← Previous</div>
        </div>

        <div className='current-photo' onDoubleClick={toggleGallery}>
          <img
            src={getPhotoUrl(currentPhotoIndex)}
            alt='Match'
            title='Double-click to see all photos'
          />
          <div className='photo-counter'>
            {currentPhotoIndex + 1} / {matchPhotos.length}
          </div>
        </div>

        <div className='preview-photo next-photo' onClick={() => goToPhoto(currentPhotoIndex + 1)}>
          <img src={getPhotoUrl(currentPhotoIndex + 1)} alt='Next' />
          <div className='photo-nav-hint'>Next →</div>
        </div>
      </div>

      <div className='photo-thumbnails'>
        {matchPhotos.map((photo, index) => (
          <div
            key={index}
            className={`thumbnail ${index === currentPhotoIndex ? 'active' : ''}`}
            onClick={() => setCurrentPhotoIndex(index)}
          >
            <img src={photo.url} alt={`Thumbnail ${index + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PhotosTab;
